import { render } from "./TopNav.vue?vue&type=template&id=9b26c474"
import script from "./TopNav.vue?vue&type=script&lang=ts"
export * from "./TopNav.vue?vue&type=script&lang=ts"
script.render = render

export default script